import {
  ORDER_BUTTON_CLICKED,
  PLACE_ORDER,
  ERROR_PLACE_ORDER,
} from '../actions/order/types';
import { ORDER_CONF_EMAIL_SEND_SUCCESS } from '../actions/userInformation/types';

import { setOrderIdDimension } from '../gtmMetrics';

const initState = {
  currentOrder: null,
  sendResult: null,
  orderProcessing: false,
  orders: {},
};

const orders = (state = initState, action) => {
  switch (action.type) {
    case PLACE_ORDER: {
      const { payload } = action;
      setOrderIdDimension(payload);
      return {
        ...state,
        currentOrder: payload,
        orderProcessing: false,
      };
    }
    case ORDER_BUTTON_CLICKED:
      return {
        ...state,
        orderProcessing: true,
      };
    case ORDER_CONF_EMAIL_SEND_SUCCESS:
      return {
        ...state,
        sendResult: true,
      };
    case ERROR_PLACE_ORDER:
      return {
        ...state,
        orderProcessing: false,
      };
    default:
      return state;
  }
};

export default orders;



// WEBPACK FOOTER //
// ./src/reducers/orders.js